import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EnterpriseEventClient, EnterpriseEventRequestPayload } from './enterprise-event-client';

@Injectable({
  providedIn: 'root',
})
export class EnterpriseEventService {
  private readonly enterpriseEventClient: EnterpriseEventClient;

  constructor() {
    this.enterpriseEventClient = EnterpriseEventClient.getInstance(
      environment.env,
      undefined
    );
  }

  public dispatchEnterpriseEvent(eventPayload: EnterpriseEventRequestPayload) {
    return this.enterpriseEventClient.dispatchEnterpriseEvent(eventPayload);
  }
}
